export default function formatAmount(amount, amountDisplay, theme) {
  const isWholeNumber = Number.isInteger(Number(amount));
  let formatted = new Intl.NumberFormat('nl-NL', {
    style: amountDisplay === 'amount' ? 'currency' : 'decimal',
    currency: 'EUR',
    minimumFractionDigits: isWholeNumber ? 0 : 2,
    useGrouping: true
  }).format(amount);

  if (isWholeNumber && theme?.showDashForWholeNumberInAmountButtons) {
    formatted += ',-';
  }

  if (amountDisplay === 'amountEuroText') {
    formatted += ' euro';
  }

  return formatted;
}
